import React, { useState } from 'react';
import Icon from '../AppIcon';

const ProjectContextBar = ({ 
  project = {
    name: 'Telecom Infrastructure Upgrade',
    version: 'v2.1',
    status: 'In Progress',
    lastModified: '2026-01-28',
    phase: 'BOQ Development'
  },
  onNavigateToProject,
  onNavigateToVersion
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const getStatusColor = (status) => {
    const statusColors = {
      'Draft': 'bg-muted text-muted-foreground',
      'In Progress': 'bg-primary/10 text-primary',
      'Under Review': 'bg-warning/10 text-warning',
      'Approved': 'bg-success/10 text-success',
      'Rejected': 'bg-error/10 text-error',
      'Completed': 'bg-success/10 text-success'
    };
    return statusColors?.[status] || 'bg-muted text-muted-foreground';
  };

  const getPhaseIcon = (phase) => {
    const phaseIcons = {
      'Forecast': 'TrendingUp',
      'Estimate': 'Calculator',
      'BOQ Development': 'FileSpreadsheet',
      'RFQ': 'FileText',
      'Procurement': 'ShoppingCart',
      'Final': 'CheckCircle'
    };
    return phaseIcons?.[phase] || 'FolderKanban';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  const handleProjectClick = () => {
    if (onNavigateToProject) {
      onNavigateToProject(project);
    }
  };

  const handleVersionClick = () => {
    if (onNavigateToVersion) {
      onNavigateToVersion(project);
    }
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="w-full bg-card border-b border-border shadow-sm">
      <div className="flex items-center justify-between h-14 px-6">
        <div className="flex items-center gap-4 flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <Icon name={getPhaseIcon(project?.phase)} size={20} color="var(--color-primary)" />
            <button
              onClick={handleProjectClick}
              className="text-sm font-semibold text-foreground hover:text-primary transition-smooth truncate max-w-xs"
            >
              {project?.name}
            </button>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
            <button
              onClick={handleVersionClick}
              className="text-sm text-muted-foreground hover:text-foreground transition-smooth"
            >
              {project?.version}
            </button>
          </div>

          <div className={`hidden md:inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${getStatusColor(project?.status)}`}>
            {project?.status}
          </div>

          <div className="hidden lg:flex items-center gap-2 text-xs text-muted-foreground">
            <Icon name="Clock" size={14} />
            <span>Modified {formatDate(project?.lastModified)}</span>
          </div>
        </div>

        <button
          onClick={toggleExpand}
          className="md:hidden flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted transition-smooth"
          aria-label="Toggle project details"
        >
          <Icon 
            name={isExpanded ? "ChevronUp" : "ChevronDown"} 
            size={18} 
          />
        </button>
      </div>
      {isExpanded && (
        <div className="md:hidden px-6 pb-4 space-y-2 border-t border-border pt-3">
          <div className="flex items-center justify-between">
            <span className="text-xs text-muted-foreground">Version</span>
            <button
              onClick={handleVersionClick}
              className="text-sm text-foreground hover:text-primary transition-smooth"
            >
              {project?.version}
            </button>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-xs text-muted-foreground">Status</span>
            <div className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${getStatusColor(project?.status)}`}>
              {project?.status}
            </div>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-xs text-muted-foreground">Last Modified</span>
            <span className="text-sm text-foreground">{formatDate(project?.lastModified)}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-xs text-muted-foreground">Phase</span>
            <span className="text-sm text-foreground">{project?.phase}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectContextBar;